import localFont from 'next/font/local';

import type { FontFamilies } from './types';

const italianPlate = localFont({
  src: [
    {
      path: '../../public/fonts/ItalianPlateNo2-Demibold.woff2',
      weight: '700',
      style: 'normal',
    },
    {
      path: '../../public/fonts/ItalianPlateNo2-Regular.woff2',
      weight: '400',
      style: 'normal',
    },
    {
      path: '../../public/fonts/ItalianPlateNo2-Extralight.woff2',
      weight: '200',
      style: 'normal',
    },
  ],
  display: 'swap',
});

const openSans = localFont({
  src: [
    {
      path: '../../public/fonts/OpenSans-Bold.woff2',
      weight: '700',
      style: 'normal',
    },
    {
      path: '../../public/fonts/OpenSans-Regular.woff2',
      weight: '400',
      style: 'normal',
    },
  ],
  display: 'swap',
});

// @TODO: change otf to woff2
const breitlingFont = localFont({
  src: [
    {
      path: '../../public/fonts/breitling_font.otf',
      weight: 'normal',
      style: 'normal',
    },
  ],
  display: 'swap',
});

const engravingBlock = localFont({
  src: [
    {
      path: '../../public/fonts/engraving-block.woff2',
      weight: 'normal',
      style: 'normal',
    },
  ],
  display: 'swap',
  preload: false,
});

const engravingCursive = localFont({
  src: [
    {
      path: '../../public/fonts/engraving-cursive.woff2',
      weight: 'normal',
      style: 'normal',
    },
  ],
  display: 'swap',
  preload: false,
});

const fontFamilies: FontFamilies = {
  openSans: openSans.style.fontFamily,
  italianPlate: italianPlate.style.fontFamily,
  breitlingFont: breitlingFont.style.fontFamily,
  engravingBlock: engravingBlock.style.fontFamily,
  engravingCursive: engravingCursive.style.fontFamily,
};

export { fontFamilies };
